import { Input, Output, ViewChild, EventEmitter, Directive } from '@angular/core';
import { IEcgData } from '../ecg-viewer-module/models/iecgdata';
import { ChartViewModel, LayerViewModel } from '../ecg-viewer-module/view-models/chart-viewmodel';

import { EcgState } from '../ecg-viewer-module/redux/ecgstate';

import { EcgConfiguration } from '../app/resolvers/ecg-configuration';
import { EcgViewerComponent } from '../ecg-viewer-module/ecg-viewer/ecg-viewer.component';

@Directive()
export class EcgMultiViewer {
    // events

    @Output()
    selectChange: EventEmitter<Array<LayerViewModel>> = new EventEmitter<Array<LayerViewModel>>();

    @Output()
    activeChange: EventEmitter<LayerViewModel> = new EventEmitter<LayerViewModel>();

    // data members

    @ViewChild(EcgViewerComponent)
    ecgViewer!: EcgViewerComponent;

    @Input()
    ecgConfiguration!: EcgConfiguration;

    @Input()
    ecgState = new EcgState();

    chart = new ChartViewModel();
    layers = new Array<LayerViewModel>();

    get integrated() {
        return false;
    }

    // public functions

    activateLayer(currentLayer?: LayerViewModel) {
        if (!this.ecgViewer) {
            return;
        }

        for (const layer of this.layers) {
            layer.active = false;
            layer.selected = false;
        }

        this.ecgViewer?.ecgChart?.clearAllMeasures();
        if (!!currentLayer) this.chart.activeLayer = currentLayer;

        this.chart.layers.splice(0, this.chart.layers.length);
        if (currentLayer) {
            currentLayer.active = true;
            currentLayer.selected = true;
            this.chart.layers.push(currentLayer);
        }

        this.activeChange.emit(currentLayer);
    }

    selectLayer(currentLayer: LayerViewModel, selected: boolean = true) {
        if (currentLayer == this.chart.activeLayer) return;

        currentLayer.selected = selected;

        this.chart.isBusy = true;

        //setTimeout(() => {

        this.chart.layers.splice(0, this.chart.layers.length);//???????
        this.layers.filter((layer) => layer.selected).forEach((layer) => this.chart.layers.push(layer));

        this.chart.isBusy = false;

        this.selectChange.emit(this.chart.layers);
        //});
    }

    addLayer(ecgData: IEcgData): LayerViewModel {
        let ecgLayer = new LayerViewModel(ecgData);
        ecgLayer.title = ecgData.title ? ecgData.title : 'Layer ' + this.layers.length;
        this.layers.push(ecgLayer);

        return ecgLayer;
    }

    removeLayer(layer: LayerViewModel) {
        let index = this.layers.indexOf(layer);
        if (index < 0) return;

        this.layers.splice(index, index);
    }
}
